/**
 * URL-hash keys for the labs (offices) feature's deep-linkable overlays, bound
 * via `useHashDialog` / `useHashParamDialog` (see `@/hooks/use-hash-dialog`).
 * Offices live in a config blob keyed by array index, so row-scoped overlays
 * carry that index (`_idx`) as the hash param (`#edit/2`).
 */
export const LABS_HASH = {
  /** `#create` — LabsFormDialog in add mode. */
  create: 'create',
  /** `#edit/<idx>` — LabsFormDialog editing the office at that array index. */
  edit: 'edit',
  /** `#delete/<idx>` — single-office delete confirmation. */
  delete: 'delete',
  /** `#bulk-delete` — bulk delete confirmation (action bar). */
  bulkDelete: 'bulk-delete'
} as const;

export type LabsHashKey = (typeof LABS_HASH)[keyof typeof LABS_HASH];
